import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { INCLUDED } from '../data/content';
import { BUY_ANCHOR, CHECKOUT_URL } from '../utils/constants';
export function Pricing() {
  return <section id={BUY_ANCHOR} aria-labelledby="pricing-title" className="w-full scroll-mt-10 bg-soft px-3 py-6 sm:px-5" data-id="element-178" data-mp="2oktprnty6eje">
      <div className="mx-auto max-w-xl text-center" data-id="element-179" data-mp="1vts3l2ru7iqd">
        <h2 id="pricing-title" className="font-head text-2xl uppercase leading-[0.98] text-navy sm:text-4xl" data-id="element-180" data-mp="1vujxm95sd8ej">
          Everything included. One single price.
        </h2>
        <p className="mt-0.5 text-[13px] text-muted" data-id="element-181" data-mp="25shkas7zyx51">No subscriptions. No hidden charges.</p>

        <div className="mt-2.5 overflow-hidden rounded-2xl border-2 border-navy bg-white text-left" data-id="element-182" data-mp="20sv88m3wnmxt">
          <div className="bg-navy px-4 py-2.5 text-center" data-id="element-183" data-mp="3h6lf20mespb5">
            <h3 className="font-head text-lg uppercase leading-none text-white sm:text-2xl" data-id="element-184" data-mp="3h97jhre06op5">
              Kids Learning Ready™
            </h3>
            <p className="mt-0.5 text-[10px] uppercase tracking-widest text-white/70 sm:text-xs" data-id="element-185" data-mp="3vyf6oqmway1b">
              The Complete Visual Learning System For Kids
            </p>
          </div>

          <div className="p-3 sm:p-4" data-id="element-186" data-mp="9rz2deocdh2y">
            <p className="font-head text-[11px] uppercase tracking-widest text-muted" data-id="element-187" data-mp="9t0apbdz3pgz">What you get</p>
            <ul className="mt-1 grid gap-0.5 sm:grid-cols-2" data-id="element-188" data-mp="eqjzv6c7lmnp">
              {INCLUDED.map(item => <li key={item} className="flex items-start gap-1.5 text-[12px] leading-snug text-navy sm:text-[13px]" data-id="element-189" data-mp="3daim1ssyfem5">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-green" aria-hidden="true" data-id="element-190" data-mp="3i5xxyf7ej0fx" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-2.5 rounded-xl bg-soft p-3 text-center" data-id="element-191" data-mp="3ryn54xvx5s5g">
              <p className="text-[12px] text-muted" data-id="element-192" data-mp="2uizjto6r84l6">
                Regular Price: <span className="line-through" data-id="element-193" data-mp="2ugn1h9x33s7l">$97 USD</span>
              </p>
              <p className="font-head text-3xl leading-none text-green sm:text-5xl" data-id="element-194" data-mp="2zfpyc72wus4h">TODAY: $27 USD</p>
              <span className="mt-1 inline-block rounded-full bg-coral px-2.5 py-0.5 font-head text-[11px] uppercase tracking-wide text-white" data-id="element-195" data-mp="2rf1us36q3k7u">
                Save $70
              </span>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-navy" data-id="element-196" data-mp="3164v32rtvv62">
                One-Time Payment · Lifetime Access
              </p>
            </div>

            <div className="mt-2.5 flex flex-col items-center" data-id="element-197" data-mp="28j20glq9w4l3">
              <CtaButton href={CHECKOUT_URL} data-id="element-198" data-mp="23j5u4fu3s12d" />
              <ul className="mt-1.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-[10px] font-semibold uppercase tracking-wide text-muted" data-id="element-199" data-mp="23kgv67w5yups">
                <li className="flex items-center gap-1" data-id="element-200" data-mp="2dgk7g6kqc9qg">
                  <LockIcon className="h-3 w-3 text-navy" aria-hidden="true" data-id="element-201" data-mp="2dj6fe7bj8r97" />
                  Secure Payment
                </li>
                <li className="flex items-center gap-1" data-id="element-202" data-mp="3owilkourllyj">
                  <ZapIcon className="h-3 w-3 text-navy" aria-hidden="true" data-id="element-203" data-mp="3ovz5zesl79no" />
                  Instant Access
                </li>
                <li className="flex items-center gap-1" data-id="element-204" data-mp="59gr6e6vm5sk">
                  <CreditCardIcon className="h-3 w-3 text-navy" aria-hidden="true" data-id="element-205" data-mp="5b1ky1ld9kpd" />
                  7-Day Guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}